import { createContext } from 'react';

import type { SidebarToggleMeta } from '../Sidebar/useSidebarState';

type ProjectEntitySidebarContextType = {
  isVisible: boolean;
  toggle(meta?: SidebarToggleMeta): void;
};

export const ProjectEntitySidebarContext = createContext<ProjectEntitySidebarContextType | undefined>(undefined);
